/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Site_SubmitInputs */

const en_site_submit = /** @type {(inputs: Site_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dissect now`)
};

const id_site_submit = /** @type {(inputs: Site_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bedah sekarang`)
};

/**
* | output |
* | --- |
* | "Dissect now" |
*
* @param {Site_SubmitInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const site_submit = /** @type {((inputs?: Site_SubmitInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Site_SubmitInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_site_submit(inputs)
	return en_site_submit(inputs)
});